import { Component, ViewEncapsulation, inject } from '@angular/core';
import { Menu, MenuService } from '@core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-topmenu',
  host: {
    class: 'matero-topmenu',
  },
  templateUrl: './topmenu.component.html',
  styleUrls: ['./topmenu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TopmenuComponent {
  menuService = inject(MenuService);

  public menus: Observable<Menu[]>;

  constructor() {
    this.menus = this.menuService.getFilteredMenu$();
  }

  // Delete empty values and rebuild route
  buildRoute(routes: string[]) {
    let route = '';
    routes.forEach(item => {
      if (item && item.trim()) {
        route += `/${item.replace(/^\/+|\/+$/g, '')}`;
      }
    });
    return route;
  }
}
